var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container mt-5" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "mb-5 row" }, [
      _c(
        "div",
        { staticClass: "col-lg-3 col-sm-6" },
        _vm._l(_vm.locations, function (l, i) {
          return _c("location-label", {
            key: "lc" + i,
            class: { selected: l == _vm.selectedLocation },
            attrs: { location: l },
            on: { "item-selected": _vm.locationSelected },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-lg-9 col-sm-6" },
        [
          _c("locations-map", {
            attrs: {
              locations: _vm.locations,
              selectedLocation: _vm.selectedLocation,
            },
            on: { "item-selected": _vm.locationSelected },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "heading-title mt-5 mb-4" }, [
      _c("h1", [_vm._v("LOCATIONS")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }